"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var async_1 = __importDefault(require("react-select/async"));
var mobx_react_1 = require("mobx-react");
var axios_1 = __importDefault(require("axios"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var WatchSelect = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    var _b = (0, react_1.useState)(''), inputValue = _b[0], setInputValue = _b[1];
    var _c = (0, react_1.useState)([]), defaultOptions = _c[0], setDefaultOptions = _c[1];
    var _d = (0, react_1.useState)([]), allOptions = _d[0], setAllOptions = _d[1];
    (0, react_1.useEffect)(function () {
        var loadDefaultOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, brands, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get('/api/brands')];
                    case 1:
                        response = _a.sent();
                        brands = response.data.brands || [];
                        setDefaultOptions(brands);
                        setAllOptions(brands);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error loading default options:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        loadDefaultOptions();
    }, []);
    var debouncedLoadOptions = (0, react_1.useCallback)((0, debounce_1.default)(function (inputValue, callback) { return __awaiter(void 0, void 0, void 0, function () {
        var response, brands, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!inputValue) {
                        callback(defaultOptions);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.get("/api/brands/search?q=".concat(encodeURIComponent(inputValue)))];
                case 2:
                    response = _a.sent();
                    brands = response.data.brands || [];
                    callback(brands);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('Error searching brands:', error_2);
                    callback([]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, 300), [defaultOptions]);
    var loadOptions = function (inputValue, callback) {
        debouncedLoadOptions(inputValue, callback);
    };
    var handleChange = function (selected, actionMeta) {
        if (selected) {
            var syntheticEvent = {
                target: {
                    value: selected.value
                }
            };
            store.handleChange(syntheticEvent);
        }
        else {
            // Handle clearing the selection
            var syntheticEvent = {
                target: {
                    value: ''
                }
            };
            store.handleChange(syntheticEvent);
        }
    };
    var selectedOption = store.optionStores.find(function (opt) { return opt.value === store.value; });
    var selectedValue = selectedOption ? {
        value: selectedOption.value,
        label: selectedOption.label,
    } : null;
    return (react_1.default.createElement("div", { id: "watch-select-wrapper", className: "estimateForm-InputWrapper_Input" },
        react_1.default.createElement(async_1.default, { name: store.name, value: selectedValue, loadOptions: loadOptions, onChange: handleChange, inputValue: inputValue, onInputChange: setInputValue, isDisabled: store.disabled, placeholder: "\u30D6\u30E9\u30F3\u30C9\u3092\u9078\u629E", isClearable: true, noOptionsMessage: function () { return "候補なし"; }, loadingMessage: function () { return "検索中です……"; }, defaultOptions: defaultOptions, cacheOptions: true, styles: {
                menu: function (baseStyles) { return (__assign(__assign({}, baseStyles), { position: 'relative' })); },
                menuList: function (baseStyles) { return (__assign(__assign({}, baseStyles), { width: '100%', position: 'absolute', backgroundColor: '#fff' })); }
            } })));
});
exports.default = WatchSelect;
